module.exports = __webpack_public_path__ + "static/media/DataEntrySVG.f22fb558.svg";